<template>
  <div class="tracking-page">
    <tracking-page-header
      title="Doctor slots vs patient demand"
      subtitle="Compare available appointment times with how many people want them. Use this to decide when to add clinicians."
      :from-date="fromDate"
      :to-date="toDate"
      :loading="loading"
      :chat-filters="chatFilters"
      :page-summary="pageSummary"
      @apply="fromDate = $event.fromDate; toDate = $event.toDate; loadData()"
      @refresh="loadData"
    />

    <div class="trk-kpi-grid">
      <div class="trk-kpi"><div class="trk-kpi-label">Slots available</div><div class="trk-kpi-value">{{ formatNumber(capacity.totalAvailable) }}</div></div>
      <div class="trk-kpi"><div class="trk-kpi-label">Slots booked</div><div class="trk-kpi-value">{{ formatNumber(capacity.totalBooked) }}</div></div>
      <div class="trk-kpi"><div class="trk-kpi-label">Patient demand</div><div class="trk-kpi-value">{{ formatNumber(capacity.totalDemand) }}</div></div>
      <div class="trk-kpi"><div class="trk-kpi-label">Unmet demand</div><div class="trk-kpi-value">{{ formatNumber(capacity.unfulfilledDemand) }}</div><div class="trk-kpi-help">People wanting times with low supply</div></div>
    </div>

    <div class="trk-panel" v-if="(capacity.recommendedWindows || []).length">
      <div class="trk-panel-head"><div><h2>Suggested staffing windows</h2><p>Add capacity in these hours first</p></div></div>
      <div class="trk-panel-body">
        <ul class="mb-0">
          <li v-for="(item, idx) in capacity.recommendedWindows" :key="idx">{{ item }}</li>
        </ul>
      </div>
    </div>

    <div class="trk-panel">
      <div class="trk-panel-head"><div><h2>Hour-by-hour view</h2><p>Green utilisation is healthy; high unmet demand needs more slots</p></div></div>
      <div class="trk-panel-body p-0">
        <table class="table trk-table mb-0" v-trk-resizable="'capacity-hours'">
          <thead>
            <tr>
              <th>Date</th>
              <th>Hour</th>
              <th>Available</th>
              <th>Booked</th>
              <th>Demand</th>
              <th>Used</th>
              <th>Unmet</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, idx) in (capacity.rows || [])" :key="idx">
              <td>{{ row.consultationDate }}</td>
              <td>{{ row.slotHour }}:00</td>
              <td>{{ formatNumber(row.available) }}</td>
              <td>{{ formatNumber(row.booked) }}</td>
              <td>{{ formatNumber(row.demand) }}</td>
              <td><span class="trk-pill" :class="row.utilisationPercent > 85 ? 'warn' : 'ok'">{{ formatPct(row.utilisationPercent) }}</span></td>
              <td><span class="trk-pill" :class="row.unfulfilled > 0 ? 'bad' : 'ok'">{{ formatNumber(row.unfulfilled) }}</span></td>
            </tr>
            <tr v-if="!(capacity.rows || []).length">
              <td colspan="7">
                <div class="trk-empty">
                  <strong>No capacity data yet</strong>
                  Demand appears once patients view/select slots. Supply appears after slot snapshots are saved.
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import TrackingPageHeader from './TrackingPageHeader.vue';
import { defaultDateRange, formatNumber, formatPct, rangeParams } from './trackingShared';

export default {
  name: 'TrackingCapacity',
  components: { TrackingPageHeader },
  data() {
    const range = defaultDateRange(7);
    return {
      fromDate: range.fromDate,
      toDate: range.toDate,
      capacity: {},
      loading: false
    };
  },
  created() { this.loadData(); },
  computed: {
    chatFilters() {
      return rangeParams(this.fromDate, this.toDate);
    },
    pageSummary() {
      return `${this.formatNumber(this.capacity.totalDemand)} demand vs ${this.formatNumber(this.capacity.totalAvailable)} available; ${this.formatNumber(this.capacity.unfulfilledDemand)} unmet`;
    }
  },
  methods: {
    formatNumber,
    formatPct,
    loadData() {
      this.loading = true;
      this.$onboardingTrackingService.getCapacity({
        ...rangeParams(this.fromDate, this.toDate),
        timezone: 'Europe/London'
      }).then((res) => {
        this.capacity = (res && res.data) || {};
      }).finally(() => { this.loading = false; });
    }
  }
};
</script>
